export default "/images/ec0f529e80b13f1b7c28ddd9b0aed621.avif";